import './src/main.css'
import Decoration3 from './src/main.vue'

export default function (Vue) {
  Vue.component(Decoration3.name, Decoration3)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/decoration3/index.js